const { default: Swiper } = require('swiper');
const { Autoplay, EffectFade } = require('swiper/modules');

const sections = document.querySelectorAll('section.collections');

if (sections.length) {
    sections.forEach(section => {
        const swiperElement = section.querySelector('.swiper');
        if (swiperElement) {
            const slideBullets =
                swiperElement.querySelectorAll('.swiper-bullet');
            const swiper = new Swiper(swiperElement, {
                slidesPerView: 1,
                modules: [Autoplay, EffectFade],
                effect: 'fade',
                fadeEffect: {
                    crossFade: true,
                },
                autoplay: {
                    disableOnInteraction: false,
                    waitForTransition: false,
                    delay: 8000,
                },
            });

            if (slideBullets) {
                swiper.on('slideChange', e => {
                    const { activeIndex } = e;
                    slideBullets.forEach((bullet, index) => {
                        if (index === activeIndex) {
                            bullet.classList.add('active');
                        } else {
                            bullet.classList.remove('active');
                        }
                    });
                });

                slideBullets.forEach((bullet, index) => {
                    bullet.addEventListener('click', () => {
                        swiper.slideTo(index);
                    });
                });
            }
        }
    });
}
